<div class="form-group optionbox mb-0">
    <select class="form-control custom-select pl-3" (change)="onChange($event)" [(ngModel)]="selectedId">
        <option class="title" value="">{{ title | translate}}</option>  
        <option *ngFor="let item of data" [value]="item.id">
            {{item.name}}
        </option>                        
    </select>
</div>